import React from 'react';
import Hero from './components/Hero';
import FeaturedCollection from './components/FeaturedCollection';
import Promotional from './components/Promotional';
import TrendingNow from './components/TrendingNow';
import WhyOptex from './components/WhyOptex';
import FeaturedProducts from './components/FeaturedProducts';
import FaceShape from './components/FaceShape';
import VirtualTryOn from './components/VirtualTryOn';
import Testimonials from './components/Testimonials';
import FinalCTA from './components/FinalCTA';

const Home = () => {
  return (
    <>
      <Hero />
      <FeaturedCollection />
      <Promotional />
      <TrendingNow />
      <FeaturedProducts />
      <VirtualTryOn />
      <FaceShape />
      <WhyOptex />
      <Testimonials />
      <FinalCTA />
    </>
  );
};

export default Home;
